// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-b9f3db70]{-webkit-box-orient:vertical;-webkit-line-clamp:3;display:-webkit-box;max-height:3.375em}@media (min-width:768px){.title[data-v-b9f3db70]{max-height:4.05em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
